import { Injectable } from '@angular/core';
import { Observable, of, throwError, from } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import {Gallery} from '../../Models/gallery';

const apiUrl = "../datas/gallery.json";

@Injectable({
  providedIn: 'root'
})
export class GalleryService {

  constructor(private http:HttpClient) { }
  
  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }

  getGalleryImages (): Observable<Gallery[]> {
    return this.http.get<Gallery[]>(apiUrl)
      .pipe(
        tap(),
        catchError(this.handleError('getGalleryImages', []))
      );
  }
}
